import { Add01Icon, MinusSignIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Stack, Typography, IconButton } from "@mui/material";
interface Props {
  total: number;
  minimum?: number;
  size?: 'large' | 'small';
  onAdd: () => void;
  onRemove: () => void;
}

const QuantitySelector = ({ total, minimum = 1, size = 'large', onAdd, onRemove }: Props) => {
  const handleRemove = () => {
    if (total > minimum) {
      onRemove();
    }
  };

  return (
    <Stack direction={"row"} spacing={2} alignItems={"center"} justifyContent={"center"}>
      <IconButton onClick={handleRemove} size={size} color="secondary" sx={{ border: "1px solid ", boxSizing: "border-box" }}>
        <HugeiconsIcon icon={MinusSignIcon} />
      </IconButton>
      <Typography>{total}</Typography>
      <IconButton onClick={onAdd} size={size} color="secondary" sx={{ border: "1px solid", boxSizing: "border-box" }}>
        <HugeiconsIcon icon={Add01Icon} />
      </IconButton>
    </Stack>
  );
};

export default QuantitySelector;
